import { Fragment, useEffect, useState, useRef } from "react";
import { Switch } from "@headlessui/react";

import { Disclosure, Transition } from '@headlessui/react'

import { Combobox } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon, XMarkIcon, ExclamationTriangleIcon } from '@heroicons/react/20/solid'
import { FunnelIcon, ArrowUpIcon, ArrowDownIcon } from '@heroicons/react/20/solid'

const statuses = {
  Pagada: { Color: 'text-green-600 bg-green-100 ring-green-400/10', Texto: 'text-green-400', IconoS: CheckIcon, },
  Pendiente: { Color: 'text-yellow-700 bg-yellow-100 ring-yellow-400/10', Texto: 'text-yellow-400', IconoS: ExclamationTriangleIcon, },
  Vencida: { Color: 'text-red-700 bg-red-100 ring-red-400/10', Texto: 'text-red-400', IconoS: XMarkIcon, },
}

// para pagos
/* Tipos de tags soportados en el grid 
  link: hiper vínculo
  button: botón cuadrado
  switch: toggle button
  textBox : cuadros de texto
  text: solo texto

*/

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const LoadingGrid = ({
  
  columnas=[],
  titulo = "",
  subtitulo = "",
  reinscrito,
  confiable = false,
  preautorizado = false,
  tipoGrid = "",
  reg_pag
}) => {
  console.log(columnas)
  const [width] = useState(window.screen.width);
  const [height] = useState(window.screen.height);
  const [position, setPosition] = useState("");
  const [dropDown, setDropDown] = useState(false);
  const storeRefs = useRef([]);

  const [isShowing, setIsShowing] = useState(false)
  const [isOrden, setIsOrden] = useState(false)

  //storeRefs.current = [];
  let alumnos = [{name:''},{name:''},{name:''},{name:''},{name:''},{name:''},{name:''},{name:''},]
  const [query, setQuery] = useState('')
  const [selectedPerson, setSelectedPerson] = useState(alumnos)

  const [dataAlumnos, setdataAlumnos] = useState(alumnos)
  


  const filteredAlumnos =
    query === ''
      ? alumnos
      : alumnos.filter((x) =>
        x.Carnet
          .toLowerCase()
          .replace(/\s+/g, '')
          .includes(query.toLowerCase().replace(/\s+/g, ''))
      )

  const handleFilterClose = () => {
    if (isShowing === true) {
      setQuery('')
      setSelectedPerson('')
      setdataAlumnos(alumnos)
    }
    setIsShowing((isShowing) => !isShowing)
  }


  const handleOrder = () => {
    const data = alumnos.sort((a, b) => {
      if (isOrden === true) {
        if (a.Carnet < b.Carnet) {
          return -1;
        }
      } else {
        if (a.Carnet > b.Carnet) {
          return -1;
        }
      }
    });
    setIsOrden((isShowing) => !isShowing)
    setdataAlumnos(data)
    // console.log('Orden', data)
  }

  const handleFilterA = (alumno, id) => {
    let dataA = []
    dataA = [...alumnos.filter(a => { return Object.values(a)[id] === Object.values(alumno)[id] })]

    if (dataA.length === 0) {
      dataA = [...alumnos]
    }
    setSelectedPerson(alumno)
    setdataAlumnos(dataA)
  }

  const generateRecords = () => {
    let alumnos = []
    for (let i = 0; i < reg_pag; i++) {
        alumnos.push({ name: '' })
    }
    return alumnos
  }
  useEffect(() => {
    
    
  }, []);// alumnos




  return (
    <>
      <div
        className={
          "overflow-hidden px-4 sm:px-6 lg:px-8 p-4 pb-2  divide-y divide-gray-300" +
            confiable || preautorizado
            ? ""
            : " h-full "
        }
      >
        <div className={"sm:flex sm:items-center p-2 "}>
          <div className="sm:flex-auto">
            <h1 className="text-lg font-semibold text-white">{titulo}</h1>
            <p className="text-sm text-grisMira">{subtitulo}</p>
          </div>
        </div>
        <div className="mt-2 flex flex-col p-3 pt-0 pb-0">
          <div
            className={
              "-mx-4 sm:-mx-6 " + confiable || preautorizado
                ? " lg:mx-0 "
                : " lg:-mx-8 "
            }
          >
            <div className="overflow-x-auto">
              <div className="mb-4 h-auto">
                <table
                  className="min-w-full border-separate overflow-scroll "
                  style={{ borderSpacing: 0 }}
                >
                  <thead className="bg-secundarioMira">
                    <tr>
                      {columnas?.map(({ name, id, filter = 0, ordenar = 0 }) =>
                        name !== "" && filter === 0 && ordenar === 0 ? (
                          <th
                            key={Math.random(20)}
                            scope="col"
                            className={id === 0 && position === "portrait"
                              ? " left-0 bg-secundarioMira sticky top-0 z-10 border-b border-gray-300 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-grisMira sm:pl-6 lg:pl-8 "
                              : "bg-secundarioMira top-0 z-10 border-b border-gray-300 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-grisMira sm:pl-6 lg:pl-8" +
                              (tipoGrid === "asistencia" ? " hidden" : "")}
                          >
                            {name}
                          </th>
                        ) : filter === 1 || ordenar === 1 ? (
                          <>
                            <th
                              key={Math.random(20)}
                              scope="col"
                              className="relative col-start-1 row-start-1 py-4 border-b border-gray-300"
                            >
                              <Disclosure
                                as="section"
                                aria-labelledby="filter-heading"
                              >
                                <div className="mx-auto flex max-w-7xl space-x-2 divide-x divide-gray-200 px-1 text-sm sm:px-6 lg:px-4">
                                  <div className="flex flex-row text-sm font-semibold text-grisMira whitespace-pre-wrap">
                                    {filter === 1 &&
                                      <Disclosure.Button className="group flex items-center text-sm font-semibold text-grisMira" onClick={() => handleFilterClose()}
                                      >
                                        <FunnelIcon className={isShowing === true ? "h-5 w-5 flex-none text-secundario" : "h-5 w-5 flex-none text-grisMira"} aria-hidden="true" />
                                        {name}
                                      </Disclosure.Button>
                                    }
                                    {ordenar === 1 &&
                                      <Disclosure.Button className="group flex items-center text-sm font-semibold text-grisMira" onClick={() => handleOrder(isOrden)}>
                                        {isOrden === true ?
                                          <ArrowUpIcon className={isOrden === true ? "h-5 w-5 flex-none text-secundario" : "h-5 w-5 flex-none text-grisMira"} aria-hidden="true" />
                                          : <ArrowDownIcon className={isOrden === true ? "h-5 w-5 flex-none text-secundario" : "h-5 w-5 flex-none text-grisMira"} aria-hidden="true" />
                                        }
                                        {filter === 0 && name}
                                      </Disclosure.Button>}
                                  </div>
                                </div>
                                <Transition
                                  as={Fragment}
                                  show={isShowing}
                                  enter="transition-opacity duration-75"
                                  enterFrom="opacity-0"
                                  enterTo="opacity-100"
                                  leave="transition-opacity duration-150"
                                  leaveFrom="opacity-100"
                                  leaveTo="opacity-0"
                                >
                                  <Disclosure.Panel>
                                    <div className="relative mt-2 flex">
                                      <Combobox as="div" value={selectedPerson} onChange={(value) => handleFilterA(value, id)}>
                                        <div className="relative mt-2">
                                          <Combobox.Input
                                            className="w-full rounded-md border-0 bg-secundarioMira py-1.5 pl-3 pr-10 text-white shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-secundario sm:text-sm sm:leading-6"
                                            displayValue={(person) => Object.values(person)[id]}
                                            onChange={(event) => setQuery(event.target.value)}
                                          />
                                          <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                                            <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                          </Combobox.Button>
                                          {filteredAlumnos.length > 0 && (
                                            <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full ||overflow-auto bg-secundarioMira py-1 text-sm font-semibold shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                              {filteredAlumnos?.map((person) => (
                                                <Combobox.Option
                                                  key={Object.values(person)[id]}
                                                  value={person}
                                                  className={({ active }) =>
                                                    classNames(
                                                      'relative cursor-default select-none py-2 pl-8 pr-4',
                                                      active ? 'bg-secundario text-white' : 'text-grisMira'
                                                    )
                                                  }
                                                >
                                                  {({ active, selected }) => (
                                                    <>
                                                      <span className={classNames('block truncate', selected && 'font-semibold')}>{Object.values(person)[id]}</span>

                                                      {selected && (
                                                        <span
                                                          className={classNames(
                                                            'absolute inset-y-0 left-0 flex items-center pl-1.5',
                                                            active ? 'text-white' : 'text-secundario'
                                                          )}
                                                        >
                                                          <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                        </span>
                                                      )}
                                                    </>
                                                  )}
                                                </Combobox.Option>
                                              ))}
                                            </Combobox.Options>
                                          )}
                                        </div>
                                      </Combobox>
                                    </div>
                                  </Disclosure.Panel>
                                </Transition>
                              </Disclosure>
                            </th>
                          </>) : null
                      )}
                    </tr>
                  </thead>
                  <tbody className="bg-primarioMira elementFadeIn1s ">
                    {dataAlumnos && dataAlumnos?.map((alumno, Idx) => {
                      //let color = ((alumno?.EstadoColor === null || alumno?.EstadoColor === undefined || alumno?.EstadoColor === '') ? '' : alumno?.EstadoColor)
                      let inscrito =
                        alumno?.EstadoSolicitud === null ||
                          alumno?.EstadoSolicitud === undefined ||
                          alumno?.EstadoSolicitud === ""
                          ? ""
                          : alumno?.EstadoSolicitud;
                      let re_inscrito =
                        reinscrito === null ||
                          reinscrito === undefined ||
                          reinscrito === ""
                          ? false
                          : reinscrito;
                      let IconoS = statuses[alumno?.InscripcionPagada]?.IconoS;
                      return (
                        <tr
                          key={Math.random(1000)}
                          // onClick={() => (inscrito !== 'Inscrito' ? handleAlumno(alumno,) : null)}
                          className={
                            "hover:bg-secundarioMira" +
                            (tipoGrid === "asistencia"
                              ? " hover:bg-secundarioMira grid md:table-row "
                              : "  ")
                          }
                        >
                          {columnas?.map(
                            ({
                              id,
                              type,
                              resaltado,
                              pintar,
                              colorTexto,
                              text,
                              name,
                              alt,
                              color,
                              style,
                              icono
                            }) =>
                              
                                <td
                                  key={Math.random(100)}
                                  className={classNames(
                                    id === 0 && position === "portrait"
                                      ? "w-[80%] sticky text-primarioMira bg-primarioMira left-0"
                                      : "whitespace-nowrap",
                                    Idx !== alumnos.length - 1
                                      ? "border-b-2 border-b-gray-500 "
                                      : "",
                                    "py-2 pl-4 pr-3 text-sm font-medium text-white sm:pl-6 lg:pl-8",
                                    pintar === "" ||
                                      pintar === null ||
                                      pintar === undefined
                                      ? ""
                                      : `${pintar} border-b-2 border-b-gray-200 `,
                                    style === "" ||
                                      style === null ||
                                      style === undefined
                                      ? ""
                                      : `${style}`
                                  )}
                                >
                                  
                                <div className="p-4 bg-gray-400 animate-pulse /rounded-md">
                                    </div></td>
                              
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default LoadingGrid;
